import {
	createMuiTheme
} from '@material-ui/core/styles';
import 'typeface-roboto'

export default createMuiTheme({
	typography: {
		color: '#ee8031'
	},
	palette: {
		primary: {
			light: '#f7a248',
			main: '#ee8031',
			dark: '#ea6c2e'
		},
		secondary: {
			light: '#f6f6f6',
			main: '#ded8d5',
			dark: '#2c2e33',
			contrastText: '#7e7f84'
		},
		text: {
			secondary: '#ffffff'
		}
	},
	overrides: {
		MuiButton: {
			root: {
				background: '#ee8031',
				color: 'white',
				'&:hover': {
					backgroundColor: '#',
				},
				fontSize: '1.5rem',
				padding: '3rem'
			}
		},
	}
});


// WEBPACK FOOTER //
// ./src/theme.js